module.exports = __webpack_public_path__ + "fonts/Muli-Light.13dacbc4.woff2";